import { motion } from "framer-motion";

export default function FadeIn({
  children,
  delay = 0,
  duration = 0.5,
  once = true,
  className = "",
  as: Component = "div",
}) {
  const MotionComponent = motion[Component] || motion.div;

  return (
    <MotionComponent
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once, margin: "-50px" }}
      transition={{
        duration,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      className={className}
    >
      {children}
    </MotionComponent>
  );
}
